import React, { useEffect, useState } from "react";
import ComposedCard from "../../../biblio/Cards/ComposedCard";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import { getAllGeneralDonations } from "../../../apis/actions/generalDonations.actions";
import { getDonationTypes } from "../../../apis/actions/generalDonations.actions";

const OtherGenralDonationCard = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { generalDonations, detailsGeneralDonation, donationTypes } =
    useSelector((state: RootState) => state?.generalDonations);

  const [filteredProjects, setFilteredProjects] =
    useState<any[]>(generalDonations);

  useEffect(() => {
    dispatch(getAllGeneralDonations());
    dispatch(getDonationTypes());
  }, [dispatch]);

  useEffect(() => {
    setFilteredProjects(
      generalDonations
        .filter((project: any) => project.id !== detailsGeneralDonation?.id)
        .sort((a: any, b: any) => {
          return a.sequence - b.sequence;
        })
    );
  }, [generalDonations, detailsGeneralDonation]);
  return (
    <div className="takaful--card-other-container">
      <div className="takaful--card-other-title">
        <span>تبرعات اخرى تحتاج دعمك</span>
      </div>

      <div className="takaful--cases-section">
        <div className="takaful--cases" style={{ marginTop: "10rem" }}>
          {filteredProjects.length > 0 &&
            filteredProjects
              .slice(0, 4)
              .map((project: any, index: number) => (
                <ComposedCard
                  key={index}
                  donation_type_ids={donationTypes}
                  type="التبرع العام"
                  project={project}
                  cardClass={"card-1"}
                />
              ))}
        </div>
      </div>
    </div>
  );
};

export default OtherGenralDonationCard;
